module.exports = __webpack_public_path__ + "static/media/eye-dropper.b05f5ff6.svg";